import { render, staticRenderFns } from "./InfiniteScroll.vue?vue&type=template&id=5bb182e9&"
import script from "./InfiniteScroll.vue?vue&type=script&lang=ts&"
export * from "./InfiniteScroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports